module.exports = __webpack_public_path__ + "static/media/gt86-side.c0727bdf.jpg";